<sf-card>
    <h3>Directory</h3>
    <p class="text-body-secondary">Manage your business contacts.</p>

    @if (isLoading()) {
        <p>Loading directory...</p>
    } @else {
        <table sfTable striped [responsive]="true" hover align="middle" style="min-width: 1000px">
            <thead sfTableColor="light">
                <tr>
                    <th>Name</th>
                    <th>Phone 1</th>
                    <th>Phone 2</th>
                    <th>Phone 3</th>
                    <th>Email</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (item of directory()?.items; track item.id) {
                    <tr>
                        <td>
                            <span class="fw-bold d-block">
                                {{ item.name }}
                            </span>
                            <span class="d-block">
                                {{ item.fullAddress || '-' }}
                            </span>
                        </td>
                        <td>
                            {{ item.phone1 || '-' }}
                        </td>
                        <td>
                            {{ item.phone2 || '-' }}
                        </td>
                        <td>
                            {{ item.phone3 || '-' }}
                        </td>
                        <td>
                            {{ item.emailAddress || '-' }}
                        </td>
                        <td class="text-end">
                            <button
                                sfButton
                                type="button"
                                icon="pencil"
                                size="sm"
                                (click)="onSelectedDirectory(item)"></button>
                        </td>
                    </tr>
                } @empty {
                    <tr>
                        <td colspan="6" class="text-center">No directory items available</td>
                    </tr>
                }
            </tbody>
        </table>

        @if (directory()) {
            <sf-pagination-detail
                [paginationData]="directory()!"
                (onPageChange)="onPageChanged($event)"></sf-pagination-detail>
        }
    }
</sf-card>

<sf-page-action-bar>
    <button sfButton type="button" color="success" icon="plus" (click)="onCreateNewDirectory()">Create</button>
</sf-page-action-bar>

<ng-template #directoryModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Directory Item</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="form">
            <div class="row">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-12">
                            <sf-input label="Contact Name" inputId="name" formControlName="name"></sf-input>
                        </div>

                        <div class="col-12">
                            <div class="p-2 bg-primary bg-opacity-10 rounded-2 my-2">
                                <sf-postcode-lookup
                                    label="Find Address"
                                    placeholder="Postcode"
                                    (onAddressChange)="onAddressSelected($event)"></sf-postcode-lookup>
                            </div>
                        </div>

                        <div class="col-12">
                            <sf-input
                                label="Address Line 1"
                                inputId="addressLine1"
                                formControlName="addressLine1"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input
                                label="Address Line 2"
                                inputId="addressLine2"
                                formControlName="addressLine2"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input
                                label="Address Line 3"
                                inputId="addressLine3"
                                formControlName="addressLine3"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input
                                label="Address Line 4"
                                inputId="addressLine4"
                                formControlName="addressLine4"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input label="Locality" inputId="locality" formControlName="locality"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input label="Town" inputId="town" formControlName="town"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input label="County" inputId="county" formControlName="county"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input label="Postcode" inputId="postcode" formControlName="postcode"></sf-input>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-12">
                            <sf-input label="Phone 1" inputId="phone1" formControlName="phone1"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input label="Phone 2" inputId="phone2" formControlName="phone2"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input label="Phone 3" inputId="phone3" formControlName="phone3"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input
                                label="Email Address"
                                inputId="emailAddress"
                                formControlName="emailAddress"></sf-input>
                        </div>
                        <div class="col-12">
                            <sf-input-textarea
                                label="Notes"
                                inputId="notes"
                                [maxLength]="10000"
                                formControlName="notes"></sf-input-textarea>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button sfButton type="button" color="dark" (click)="modal.close('Save click')">Cancel</button>
        @if (selectedDirectory()) {
            <button sfButton type="button" color="danger" icon="trash" (click)="onDeleteDirectory()">Delete</button>
        }
        <button sfButton type="button" color="success" icon="save" (click)="saveDirectory()">Save</button>
    </div>
</ng-template>
